export const ItemTypes = {
  PROPERTY: 'property'
}